import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EyeInvisibleOutlined,
  PauseCircleOutlined,
  SyncOutlined,
  TruckOutlined,
  UndoOutlined,
  WarningOutlined,
  RollbackOutlined
} from '@ant-design/icons'
import { Button, Col, Row } from 'antd'
import { useHistory } from 'react-router-dom'
import ROUTER from 'services/router'
import { useCODReport, useOrderReport } from 'services/swr/order'
import { Skeleton } from 'widgets/Skeleton'
import { Label, ReportBox, WrapperDashboard } from './styled'
import { numberWithCommas } from 'utils'
import ImportOrderModal from './components/ImportOrderModal'
import { useEffect, useState } from 'react'
import SWR_KEY from 'services/swr/constant'
import { mutate } from 'swr'
import useGetCustomerData from 'state/customer/hooks/useGetCustomerData'

import { ref, onValue } from 'firebase/database';
import { db } from '../../helpers/firebaseConfig';
import { customerService } from 'services'
import { useDispatch } from 'react-redux'
import { setProfile } from 'state/customer/actions'
import { APP_ENV } from 'constants/index'


const CONFIG_COD = {
  ORDER_DELIVERY_FAILED: {
    title: 'Giao hàng thất bại',
    icon: <CloseCircleOutlined className='red-icon' />,
  },
  CREATE_ORDER_FAILED: {
    title: 'Tạo đơn vận thất bại',
    icon: <WarningOutlined className='red-icon' />,
  },
  ORDER_PAYMENTED: {
    title: 'Đã thu tiền',
    icon: <CheckCircleOutlined className='green-icon' />,
  },
  ORDER_NOT_PAYMENTED: {
    title: 'Chưa lấy tiền',
    icon: <PauseCircleOutlined className='yellow-icon' />,
  },
}

const CONFIG_SUMMARY = {
  ORDER_NEW: {
    title: 'Mới tạo và chờ lấy',
    icon: <SyncOutlined className='grey-icon' />,
  },
  ORDER_SHIPPING: {
    title: 'Đang giao',
    icon: <TruckOutlined className='grey-icon' />,
  },
  ORDER_BACK_SENDER: {
    title: 'Đơn trả lại',
    icon: <UndoOutlined className='grey-icon' />,
  },
  ORDER_RETURNING: {
    title: 'Đơn trả lại',
    icon: <RollbackOutlined className='grey-icon' />,
  },
  ORDER_LOST: {
    title: 'Đơn hàng gặp sự cố',
    icon: <EyeInvisibleOutlined className='grey-icon' />,
  },
  ORDER_CANCEL: {
    title: 'Đơn bị hủy',
    icon: <DeleteOutlined className='grey-icon' />,
  }
}

const renderLoading = (total: number) => {
  return Array.from({ length: total }, (v, i) => i).map((x) => (
    <Col span={12} md={{ span: 6 }} key={x}>
      <Skeleton width={'100%'} height={115} />
    </Col>
  ))
}


const Dashboard = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const { data: orderSummaryData } = useOrderReport()
  const { data: orderCODData } = useCODReport()
  const { customerProfile } = useGetCustomerData()
  const [openModalImport, setOpenModalImport] = useState<boolean>(false)
  const [totalProcessing, setTotalProcessing] = useState<number>(0)
  const [totalOrder, setTotalOrder] = useState<number>(0)

  useEffect(() => {
    const node = APP_ENV + '/customer_' + customerProfile?.id + '/import_order'
    const dataRef = ref(db, node);
    const unsubscribe = onValue(dataRef, (snapshot) => {
      const val = snapshot.val();
      console.log(val);
      
      if (val?.proccess == 'done') {
        getProfile()
        setTotalProcessing(0)
        setTotalOrder(0)
      } else {
        setTotalProcessing(val?.proccessing)
        setTotalOrder(val?.total)
      }

    });
    return () => unsubscribe();
  }, [customerProfile]);

  useEffect(() => {
    if (customerProfile?.orderImport != null && customerProfile?.status_kyc === 2) {
      setOpenModalImport(true)
    }
  }, [customerProfile]);


  const handleClose = () => {
    setOpenModalImport(false)
    mutate(SWR_KEY.ORDERS_REPORT_SUMMARY)
    mutate(SWR_KEY.ORDERS_REPORT_COD)
    return;
  }
  
  const getProfile = () => {
    customerService.getProfile((data) => {
      const customer = data?.data?.customer;
      dispatch(setProfile(customer))
      if (customer?.orderImport == null) {
        handleClose();
      }
    })
  }

  return (
    <WrapperDashboard>
      <div className='container'>
        <div className='box-wellcome'>
          <div>
            <img width={80} src='/logo.png' alt='' />
          </div>
          <div className='wrap-text'>

            <p>Xin chào!</p>
            <p>Sẵn sàng để gửi một số bưu kiện?</p>
          </div>

          <div className='wrap-button'>
            <div><a href={ROUTER.orderCreate}>
              <Button type='primary' > ĐƠN HÀNG MỚI</Button>
            </a></div>
            <div>
              <a type='primary' href={ROUTER.orderTracking}>
                <Button type='primary' > THEO DÕI ĐƠN</Button>
              </a>
            </div>
            <div><Button type='primary' onClick={() => setOpenModalImport(true)}>
              Tạo đơn <br />bằng file Excel
            </Button></div>
          </div>
        </div>

        <div className='dashboard-item'>
          <Label>
            <p className='title'>COD tuần này</p>
          </Label>

          <Row gutter={[20, 20]}>
            {!orderCODData ? (
              renderLoading(4)
            ) : (
              <>
                {orderCODData?.map((item) => (
                  <Col span={12} md={{ span: 6 }} key={item?.key}>
                    <ReportBox onClick={() => history.push(`/theo-doi-don-van?statusCod=${item?.id}`)}>
                      <div className='top'>
                        {CONFIG_COD[item?.key]?.icon}
                        <p>{CONFIG_COD[item?.key]?.title}</p>
                      </div>
                      <p className='mid'>{numberWithCommas(item?.total_cod)}</p>
                      <p className='bottom'>Có {item?.total_order} bưu kiện</p>
                    </ReportBox>
                  </Col>
                ))}
              </>
            )}
          </Row>
        </div>

        <div className='dashboard-item'>
          <Label>
            <p className='title'>Tổng quan tuần này</p>
          </Label>

          <Row gutter={[20, 20]}>
            {!orderSummaryData ? (
              renderLoading(6)
            ) : (
              <>
                {orderSummaryData?.map((item) => (
                  <Col span={12} md={{ span: 6 }} key={item?.key}>
                    <ReportBox onClick={() => history.push(`/theo-doi-don-van?statusSumary=${item?.id}`)}>
                      <div className='top'>{CONFIG_SUMMARY[item?.key]?.icon}</div>
                      <p className='mid'>{item?.title}</p>
                      <p className='bottom'>{item?.total_order}</p>
                    </ReportBox>
                  </Col>
                ))}
              </>
            )}
          </Row>
        </div>
      </div>
      <ImportOrderModal open={openModalImport} totalProcessing={totalProcessing} totalOrder={totalOrder} onCancel={handleClose} customerProfile={customerProfile} />
    </WrapperDashboard>
  )
}

export default Dashboard
